import queryString from 'querystring';

import { createGenericDispatcher } from '../../../action/action-dispatcher-factory';
import { announcementDeliverySummaryStateForIdSelector } from '../../../reducers/message-selectors';

import * as Api from '../../../api/api';

export const loadAnnouncementDeliverySummaries = (announcementIds: Array<number>, orgId: number) =>
  createGenericDispatcher({
    name: 'LOAD_ANNOUNCEMENT_DELIVERY_SUMMARY',
    loadFunction: () =>
      Api.get(
        `/announcements/delivery-summary?${queryString.stringify({
          announcementIds,
        })}`,
      ),
    args: { announcementIds, orgId },
    shouldExecuteSelectors: (state: any) =>
      announcementIds.map((id) => announcementDeliverySummaryStateForIdSelector(state, id)),
  });
